module.exports = __webpack_public_path__ + "img/image-thumb-20.13a1ac71.jpg";